// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__Zdow4","fixedHeader":"styles_fixedHeader__EyZfs","headerContainer":"styles_headerContainer__KauFF","logo":"styles_logo__tpB1T","btn":"styles_btn__UuWR1"};